if (!customElements.get("qty-bundle")) {
  customElements.define(
    "qty-bundle",
    class QtyBundle extends HTMLElement {
      constructor() {
        super();

        this.radios = this.querySelectorAll('input[type="radio"]');
        this.options = this.querySelectorAll(".bundle-option");

        this.radios.forEach((radio) => {
          radio.addEventListener("change", this.onRadioChange.bind(this));
        });

        // Set initial quantity
        const checkedRadio = this.querySelector('input[type="radio"]:checked');
        if (checkedRadio) {
          checkedRadio.dispatchEvent(new Event("change"));
        }
      }

      onRadioChange(event) {
        const radio = event.currentTarget;

        this.options.forEach((opt) => opt.classList.remove("bundle-option--active"));
        radio.closest(".bundle-option").classList.add("bundle-option--active");


        const stickyBuy = document.querySelector('sticky-buy-button');
        const stickyPrice = stickyBuy.querySelector('.price__regular');
        const stickySale = stickyBuy.querySelector('.price__sale');
        const bundlePrice = radio.closest(".bundle-option").querySelector('.bundle-option__sticky-price');
        const bundlePriceOld = radio.closest(".bundle-option").querySelector('.bundle-option__price--old');

        if(bundlePrice && stickyPrice) {
          stickyPrice.innerText = bundlePrice.innerText;

          // Add/update quantity label
          const qty = parseInt(radio.value);
          let qtyLabel = stickyBuy.querySelector('.sticky-qty-info');
          if(qty > 1){
            if(!qtyLabel){
              qtyLabel = document.createElement('span');
              qtyLabel.className = 'sticky-qty-info';
              stickyPrice.parentNode.appendChild(qtyLabel);
            }
            qtyLabel.textContent = '(' + qty + ' sztuki)';
          } else if(qtyLabel){
            qtyLabel.remove();
          }
        }
        if(bundlePriceOld && stickySale) {
          stickySale.innerText = bundlePriceOld.innerText;
          stickySale.classList.add('visible');
          stickySale.classList.add('bundle-option__price--old');
          stickyPrice.classList.add('sticky-bundle-option__price');
        } else {
          stickySale.classList.remove('visible');
          stickyPrice.classList.remove('sticky-bundle-option__price');
        }
        

        const qty = parseInt(radio.value);
        const form =
          this.closest("form") ||
          document.querySelector('[data-type="add-to-cart-form"]');

        if (form) {
          let qtyInput = form.querySelector('input[name="quantity"]');
          if (qtyInput) {
            qtyInput.value = qty;
          } else {
            qtyInput = document.createElement("input");
            qtyInput.type = "hidden";
            qtyInput.name = "quantity";
            qtyInput.value = qty;
            form.appendChild(qtyInput);
          }
        }
      }
    }
  );
}
